import * as React from 'react';
import * as styles from './DesktopLayout.css';

export interface IDesktopLayoutProps {
  breadcrumbs: React.ReactNode;
  content: React.ReactNode;
  sidebar: React.ReactNode;
}

export const DesktopLayout: React.FC<IDesktopLayoutProps> = props => {
  const { breadcrumbs, content, sidebar } = props;

  return (
    <div className={styles['layout']} data-testid="DesktopLayout">
      <div className={styles['breadcrumbs']}>{breadcrumbs}</div>
      <div className={styles['content']}>{content}</div>
      <div className={styles['sidebar']}>{sidebar}</div>
    </div>
  );
};
